import React from "react";
import PropTypes from "prop-types";
import { Feed as SemanticFeed } from "semantic-ui-react";

import "./SimpleFeed.scss";

export const SimpleFeed = ({
  avatar_size = "md",
  content,
  timestamp,
  avatar,
  title,
}) => {
  return (
    <SemanticFeed className={`hireart-ds-feed`}>
      <SemanticFeed.Event>
        {avatar && (
          <SemanticFeed.Label className={`${avatar_size}`} image={avatar} />
        )}
        <SemanticFeed.Content>
          <SemanticFeed.Summary>
            {title}
            <SemanticFeed.Date>{timestamp}</SemanticFeed.Date>
          </SemanticFeed.Summary>
          <SemanticFeed.Extra text>{content}</SemanticFeed.Extra>
        </SemanticFeed.Content>
      </SemanticFeed.Event>
    </SemanticFeed>
  );
};

SimpleFeed.propTypes = {
  title: PropTypes.string,
  timestamp: PropTypes.string,
  avatar: PropTypes.string,
  avatar_size: PropTypes.oneOf(["sm", "md", "lg"]),
  content: PropTypes.string,
};

